/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the Tocsoft.GraphQLCodeGen toolchain https://github.com/tocsoft/GraphQLCodeGen
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {HttpClient} from 'aurelia-fetch-client';
import {inject} from 'aurelia-framework';
import { apiUrl } from '../../constants'

interface fetchClient {
    fetch(url: RequestInfo, init: RequestInit): Promise<Response>
}

class GraphQLResponse
{
    data: any
    errors: Array<{ message: string }>
}

function PostcodeLookupError(message:string, httpResponse:Response, graphqlResponse?: GraphQLResponse) {
    this.name = 'PostcodeLookupError';
    this.message = message || 'Error fetching graphql response';
    this.stack = (new Error()).stack;
    this.httpResponse = httpResponse;
    if(graphqlResponse && graphqlResponse.errors){
        this.errors = graphqlResponse.errors.map(x=>x.message);
    }
  }
  PostcodeLookupError.prototype = Object.create(Error.prototype);
  PostcodeLookupError.prototype.constructor = PostcodeLookupError;
  
export { PostcodeLookupError }

@inject(HttpClient, apiUrl)
export class PostcodeLookupClient {

    constructor(public client: fetchClient, public url: string) { }
	
	postcodeLookup(	postcode? :string) : Promise<PostcodeLookupResult>{
        return this.client.fetch(this.url, {
            method : 'POST',
            body : JSON.stringify({
                query : `query($postcode: String) {
  postcodeLookup(postcode: $postcode) {
    address1
    address2
    address3
    town
    postcode
    country
  }
}
`,
                variables : {
					postcode : postcode ,
                }
            })
        }).then(response=>{
            if(response.status != 200){
                // error result
                throw new PostcodeLookupError("http error running 'postcodeLookup', see httpResponse for more details.", response)
            }else{
                return response.json().then((json:GraphQLResponse)=>{
                    
                    if(json.errors && json.errors.length > 0){
                        throw new PostcodeLookupError("graphql error(s) running 'postcodeLookup', see errors collection fro more details", response, json)
                    }

                    const result: any = PostcodeLookupResult.fromJS(json.data);                
                    
                    return result;
                })
            }
        })
    }	
}

export class PostcodeLookupResult {
		postcodeLookup? :Array<AddressDtoResult>;

    static fromJS(json:any):PostcodeLookupResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new PostcodeLookupResult();

if(json["postcodeLookup"]){ 
		result.postcodeLookup = json["postcodeLookup"].map(v=>AddressDtoResult.fromJS(v) );	
	}

        return result;
    }
}

export class AddressDtoResult {
		address1? :string;
		address2? :string;
		address3? :string;
		town? :string;
		postcode? :string;
		country? :CountryCodeType;

    static fromJS(json:any):AddressDtoResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new AddressDtoResult();

	result.address1 = json["address1"];
	result.address2 = json["address2"];
	result.address3 = json["address3"];
	result.town = json["town"];
	result.postcode = json["postcode"];
result.country= CountryCodeType[<string>json["country"]];

        return result;
    }
}


	export enum CountryCodeType
	{
		NONE = "NONE",
		AFGHANISTAN = "AFGHANISTAN",
		ALBANIA = "ALBANIA",
		ALGERIA = "ALGERIA",
		AMERICANSAMOA = "AMERICANSAMOA",
		ANDORRA = "ANDORRA",
		ANGOLA = "ANGOLA",
		ANGUILLA = "ANGUILLA",
		ANTARCTICA = "ANTARCTICA",
		ARGENTINA = "ARGENTINA",
		ARMENIA = "ARMENIA",
		ARUBA = "ARUBA",
		AUSTRALIA = "AUSTRALIA",
		AUSTRIA = "AUSTRIA",
		AZERBAIJAN = "AZERBAIJAN",
		BAHAMAS = "BAHAMAS",
		BAHRAIN = "BAHRAIN",
		BANGLADESH = "BANGLADESH",
		BARBADOS = "BARBADOS",
		BELARUS = "BELARUS",
		BELGIUM = "BELGIUM",
		BELIZE = "BELIZE",
		BENIN = "BENIN",
		BERMUDA = "BERMUDA",
		BHUTAN = "BHUTAN",
		BOLIVIA = "BOLIVIA",
		BOSNIAANDHERZEGOVINA = "BOSNIAANDHERZEGOVINA",
		BOTSWANA = "BOTSWANA",
		BRAZIL = "BRAZIL",
		BRITISHVIRGINISLANDS = "BRITISHVIRGINISLANDS",
		BRUNEI = "BRUNEI",
		BULGARIA = "BULGARIA",
		BURKINAFASO = "BURKINAFASO",
		BURUNDI = "BURUNDI",
		CAMBODIA = "CAMBODIA",
		CAMEROON = "CAMEROON",
		CANADA = "CANADA",
		CAPEVERDE = "CAPEVERDE",
		CAYMANISLANDS = "CAYMANISLANDS",
		CENTRALAFRICANREPUBLIC = "CENTRALAFRICANREPUBLIC",
		CHILE = "CHILE",
		CHINA = "CHINA",
		COLOMBIA = "COLOMBIA",
		COMOROS = "COMOROS",
		COOKISLANDS = "COOKISLANDS",
		COSTARICA = "COSTARICA",
		CROATIA = "CROATIA",
		CUBA = "CUBA",
		CURACAO = "CURACAO",
		CYPRUS = "CYPRUS",
		CZECHREPUBLIC = "CZECHREPUBLIC",
		DEMOCRATICREPUBLICOFCONGO = "DEMOCRATICREPUBLICOFCONGO",
		DENMARK = "DENMARK",
		DJIBOUTI = "DJIBOUTI",
		DOMINICA = "DOMINICA",
		DOMINICANREPUBLIC = "DOMINICANREPUBLIC",
		EASTTIMOR = "EASTTIMOR",
		ECUADOR = "ECUADOR",
		EGYPT = "EGYPT",
		ELSALVADOR = "ELSALVADOR",
		EQUATORIALGUINEA = "EQUATORIALGUINEA",
		ERITREA = "ERITREA",
		ESTONIA = "ESTONIA",
		ETHIOPIA = "ETHIOPIA",
		FALKLANDISLANDS = "FALKLANDISLANDS",
		FAROEISLANDS = "FAROEISLANDS",
		FIJI = "FIJI",
		FINLAND = "FINLAND",
		FRANCE = "FRANCE",
		FRENCHPOLYNESIA = "FRENCHPOLYNESIA",
		GABON = "GABON",
		GAMBIA = "GAMBIA",
		GEORGIA = "GEORGIA",
		GERMANY = "GERMANY",
		GHANA = "GHANA",
		GIBRALTAR = "GIBRALTAR",
		GREECE = "GREECE",
		GREENLAND = "GREENLAND",
		GUADELOUPE = "GUADELOUPE",
		GUAM = "GUAM",
		GUATEMALA = "GUATEMALA",
		GUINEA = "GUINEA",
		GUINEABISSAU = "GUINEABISSAU",
		GUYANA = "GUYANA",
		HAITI = "HAITI",
		HONDURAS = "HONDURAS",
		HONGKONG = "HONGKONG",
		HUNGARY = "HUNGARY",
		ICELAND = "ICELAND",
		INDIA = "INDIA",
		INDONESIA = "INDONESIA",
		IRAN = "IRAN",
		IRAQ = "IRAQ",
		IRELAND = "IRELAND",
		ISLEOFMAN = "ISLEOFMAN",
		ISRAEL = "ISRAEL",
		ITALY = "ITALY",
		IVORYCOAST = "IVORYCOAST",
		JAMAICA = "JAMAICA",
		JAPAN = "JAPAN",
		JORDAN = "JORDAN",
		KAZAKHSTAN = "KAZAKHSTAN",
		KENYA = "KENYA",
		KIRIBATI = "KIRIBATI",
		KOSOVO = "KOSOVO",
		KUWAIT = "KUWAIT",
		KYRGYZSTAN = "KYRGYZSTAN",
		LAOS = "LAOS",
		LATVIA = "LATVIA",
		LEBANON = "LEBANON",
		LESOTHO = "LESOTHO",
		LIBERIA = "LIBERIA",
		LIBYA = "LIBYA",
		LIECHTENSTEIN = "LIECHTENSTEIN",
		LITHUANIA = "LITHUANIA",
		LUXEMBOURG = "LUXEMBOURG",
		MACAU = "MACAU",
		MACEDONIA = "MACEDONIA",
		MADAGASCAR = "MADAGASCAR",
		MALAWI = "MALAWI",
		MALAYSIA = "MALAYSIA",
		MALDIVES = "MALDIVES",
		MALI = "MALI",
		MALTA = "MALTA",
		MARSHALLISLANDS = "MARSHALLISLANDS",
		MAURITANIA = "MAURITANIA",
		MAURITIUS = "MAURITIUS",
		MEXICO = "MEXICO",
		MICRONESIA = "MICRONESIA",
		MOLDOVA = "MOLDOVA",
		MONACO = "MONACO",
		MONGOLIA = "MONGOLIA",
		MONTENEGRO = "MONTENEGRO",
		MONTSERRAT = "MONTSERRAT",
		MOROCCO = "MOROCCO",
		MOZAMBIQUE = "MOZAMBIQUE",
		MYANMARBURMA = "MYANMARBURMA",
		NAMIBIA = "NAMIBIA",
		NAURU = "NAURU",
		NEPAL = "NEPAL",
		NETHERLANDS = "NETHERLANDS",
		NEWCALEDONIA = "NEWCALEDONIA",
		NEWZEALAND = "NEWZEALAND",
		NICARAGUA = "NICARAGUA",
		NIGER = "NIGER",
		NIGERIA = "NIGERIA",
		NIUE = "NIUE",
		NORFOLKISLAND = "NORFOLKISLAND",
		NORTHKOREA = "NORTHKOREA",
		NORTHERNMARIANAISLANDS = "NORTHERNMARIANAISLANDS",
		NORWAY = "NORWAY",
		OMAN = "OMAN",
		PAKISTAN = "PAKISTAN",
		PALAU = "PALAU",
		PANAMA = "PANAMA",
		PAPUANEWGUINEA = "PAPUANEWGUINEA",
		PARAGUAY = "PARAGUAY",
		PERU = "PERU",
		PHILIPPINES = "PHILIPPINES",
		PITCAIRNISLANDS = "PITCAIRNISLANDS",
		POLAND = "POLAND",
		PORTUGAL = "PORTUGAL",
		PUERTORICO = "PUERTORICO",
		QATAR = "QATAR",
		REPUBLICOFTHECONGO = "REPUBLICOFTHECONGO",
		REUNION = "REUNION",
		ROMANIA = "ROMANIA",
		RUSSIA = "RUSSIA",
		RWANDA = "RWANDA",
		SAINTBARTHELEMY = "SAINTBARTHELEMY",
		SAINTHELENA = "SAINTHELENA",
		SAINTKITTSANDNEVIS = "SAINTKITTSANDNEVIS",
		SAINTLUCIA = "SAINTLUCIA",
		SAINTMARTIN = "SAINTMARTIN",
		SAINTPIERREANDMIQUELON = "SAINTPIERREANDMIQUELON",
		SAINTVINCENTANDTHEGRENADINES = "SAINTVINCENTANDTHEGRENADINES",
		SAMOA = "SAMOA",
		SANMARINO = "SANMARINO",
		SAOTOMEANDPRINCIPE = "SAOTOMEANDPRINCIPE",
		SAUDIARABIA = "SAUDIARABIA",
		SENEGAL = "SENEGAL",
		SERBIA = "SERBIA",
		SEYCHELLES = "SEYCHELLES",
		SIERRALEONE = "SIERRALEONE",
		SINGAPORE = "SINGAPORE",
		SLOVAKIA = "SLOVAKIA",
		SLOVENIA = "SLOVENIA",
		SOLOMONISLANDS = "SOLOMONISLANDS",
		SOMALIA = "SOMALIA",
		SOUTHAFRICA = "SOUTHAFRICA",
		SOUTHKOREA = "SOUTHKOREA",
		SOUTHSUDAN = "SOUTHSUDAN",
		SPAIN = "SPAIN",
		SRILANKA = "SRILANKA",
		SUDAN = "SUDAN",
		SURINAME = "SURINAME",
		SWAZILAND = "SWAZILAND",
		SWEDEN = "SWEDEN",
		SWITZERLAND = "SWITZERLAND",
		SYRIA = "SYRIA",
		TAIWAN = "TAIWAN",
		TAJIKISTAN = "TAJIKISTAN",
		TANZANIA = "TANZANIA",
		THAILAND = "THAILAND",
		TOGO = "TOGO",
		TOKELAU = "TOKELAU",
		TRINIDADANDTOBAGO = "TRINIDADANDTOBAGO",
		TUNISIA = "TUNISIA",
		TURKEY = "TURKEY",
		TURKMENISTAN = "TURKMENISTAN",
		TUVALU = "TUVALU",
		UGANDA = "UGANDA",
		UKRAINE = "UKRAINE",
		UNITEDARABEMIRATES = "UNITEDARABEMIRATES",
		UNITEDKINGDOM = "UNITEDKINGDOM",
		UNITEDSTATES = "UNITEDSTATES",
		URUGUAY = "URUGUAY",
		UZBEKISTAN = "UZBEKISTAN",
		VANUATU = "VANUATU",
		VATICAN = "VATICAN",
		VENEZUELA = "VENEZUELA",
		VIETNAM = "VIETNAM",
		WESTERNSAHARA = "WESTERNSAHARA",
		YEMEN = "YEMEN",
		ZAMBIA = "ZAMBIA",
		ZIMBABWE = "ZIMBABWE",
	}

